import { CustomCell } from '../../components/custom-cell';
import { getStringOperators } from '../../utils/getStringOperators';
import { getNumericOperators } from '../../utils/getNumericOperators';

export const TABLE_COLUMNS = userRoles => {
	return [
		{
			headerName: '#',
			field: 'id',
			width: 100,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			type: 'number',
			cellClassName: 'id',
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Юр. лицо',
			field: 'legal',
			flex: 2,
			filterOperators: getStringOperators(),
			valueGetter: (value, row) => {
				if (!row.legal) {
					return value;
				}

				return row.legal.name;
			},
		},
		{
			headerName: 'ФИО',
			field: 'name',
			flex: 2,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Роль',
			field: 'role_id',
			flex: 1,
			sortable: false,
			type: 'singleSelect',
			valueOptions: userRoles,
			getOptionValue: value => value?.id,
			getOptionLabel: value => value?.name ?? 'Все',
			valueGetter: (value, row) => {
				if (!row.role) {
					return value;
				}

				return row.role.id;
			},
		},
		{ headerName: 'Должность', field: 'post', flex: 1, sortable: false, filterOperators: getStringOperators() },
		{
			headerName: 'Телефон',
			field: 'phone',
			flex: 1,
			sortable: false,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
		{ headerName: 'Почта', field: 'email', flex: 2, sortable: false, filterOperators: getStringOperators() },
	];
};

export const NAV_PAGE_LIST = [{ text: 'Пользователи', href: '/users' }];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
